import React, { useEffect, useRef, useState } from "react";
import MainContainer from "../components/container/MainContainer";

const LANGUAGE_PDFS = [
  {
    title: "Arabic (صحیفة وقائع بشأن مواد البیرفلوروألكیل والبولیفلوروألكیل)",
    src: "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_Arabic.pdf",
  },
  {
    title: "Farsi (\u202Bبرگه اطلاعات مواد پر و پلی فلوئوروآلکیل (PFAS).\u202C)",
    src: "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_Farsi.a2080637a4161d2a7ab7.pdf",
  },
  {
    title: "French (Fiche d’information sur les substances perfluoroalkylées et polyfluoroalkylées (PFAS))",
    src: "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_French.pdf",
  },
  {
    title: "Korean (불소계 계면활성제(PFAS) 팩트 시트)",
    src: "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_Korean.pdf",
  },
  {
    title: "Russian (Информационный бюллетень о перфторалкильных и полифторалкильных веществах (PFAS))",
    src: "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_Russian.pdf",
  },
  {
    title: "Spanish (Hoja de datos sobre las sustancias perfluoroalquiladas y polifluoroalquiladas (PFAS))",
    src: "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_Spanish.pdf",
  },
  {
    title: "Simplified Chinese (全氟及多氟烷基化合物（PFAS）情况说明书)",
    src: "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_Simplified Chinese.pdf",
  },
  {
    title: "Traditional Chinese (全氟及多氟烷基物質（PFAS）情況說明書)",
    src: "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_Traditional Chinese.pdf",
  },
  {
    title: "Vietnamese (Tờ Thông Tin về Các Chất Per- và Polyfluoroalkyl (PFAS))",
    src: "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_Vietnamese.pdf",
  },
];

// const Arabic = "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_Arabic.pdf";
// const Farsi = "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_Farsi.a2080637a4161d2a7ab7.pdf";
// const French = "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_French.pdf";
// const Korean = "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_Korean.pdf";
// const Russian = "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_Russian.pdf";
// const Simplified_Chinese = "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_Simplified Chinese.pdf";
// const Spanish = "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_Spanish.pdf";
// const Traditional_Chinese = "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_Traditional Chinese.pdf";
// const Vietnamese = "/pdfs/PFAS-FactSheets-DDW-2024_Different_Languages/PFAS-FactSheet-DDW-2024_Vietnamese.pdf";

const Communication_Plan_pdf = "/pdfs/CommunicationPlan.pdf";
const QAPP_pdf = "/pdfs/QAPP_06.30.2025.pdf";
const Background_Info = "/pdfs/Background_Info_Sampling.pdf";
const Written_Instructions = "/pdfs/Step-by-Step Instructions for PFAS Sampling.pdf";

const BOARD_ORDER_URL =
  "https://www.waterboards.ca.gov/drinking_water/certlic/drinkingwater/pfas_ddw_general_order/";
const PFAS_FACT_SHEET =
  "https://www.waterboards.ca.gov/drinking_water/certlic/drinkingwater/docs/2024/pfas-fact-sheet-ddw-2024.pdf";
const FAQ_DW =
  "https://www.waterboards.ca.gov/drinking_water/certlic/drinkingwater/docs/2024/pfaq-faq-ddw-2024.pdf";
const trainingP1VideoUrl =
  "https://player.vimeo.com/video/954151020?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";
const trainingP2VideoUrl =
  "https://player.vimeo.com/video/954170898?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479";

const Resources = () => {
  const iframeRef1 = useRef(null);
  const iframeRef2 = useRef(null);
  const [playing, setPlaying] = useState(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://player.vimeo.com/api/player.js";
    script.async = true;

    script.onload = () => {
      const iframes = [
        { ref: iframeRef1, id: 1 },
        { ref: iframeRef2, id: 2 },
      ];

      iframes.forEach(({ ref, id }) => {
        const player = new window.Vimeo.Player(ref.current);
        player.on("play", () => {
          setPlaying(id);
          if (window.innerWidth < 768) {
            player.requestFullscreen(); // Trigger full-screen mode on mobile
          } else {
            ref.current.style.width = "100%"; // Increase iframe size on desktop
            ref.current.style.height = "100%";
          }
        });
      });
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const videoContainerStyle = (id) => ({
    paddingTop: playing === id ? "56.25%" : "25%",
    position: "relative",
    width: playing === id ? "100%" : "40%",
    height: playing === id ? "100%" : "40%",
    transition: "padding-top 0.3s, width 0.3s, height 0.3s",
  });

  return (
    <section className="my-8 text-primary w-full">
      <h1 className="text-2xl md:text-3xl font-bold md:ml-8">Resources</h1>
      <MainContainer>
        <div className="text-md font-semibold my-4 text-gray-700">
          <h2 className="font-bold text-lg">DDW Material</h2>
          <div className="text-gray-700 text-md my-4">
            <ul className="list-disc ml-5">
              <li>
                <a
                  className="italic font-medium"
                  href={BOARD_ORDER_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  State Water Board Order DW 2024-0002-DDW and Cover Letter
                </a>
              </li>
              <li>
                <a
                  className="italic font-medium"
                  href={FAQ_DW}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  FAQ for DW 2024-0002-DDW
                </a>
              </li>
              <li>
                <a
                  className="italic font-medium"
                  href={PFAS_FACT_SHEET}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  PFAS Fact Sheet
                </a>
                <h3 className="list-disc ml-4">Translated Fact Sheets</h3>
                <ul>
                  {LANGUAGE_PDFS.map((translation) => (
                    <li key={translation.title} className="list-disc ml-12">
                      <a
                        className="italic font-medium"
                        href={translation.src}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {translation.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-md font-semibold my-4 text-gray-700">
          <h2 className="font-bold text-lg">Sampling Guidance</h2>
          <div className="text-gray-700 text-md my-4">
            <ul className="list-disc ml-5">
              <li>
                <a
                  className="italic font-medium"
                  href={QAPP_pdf}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Quality Assurance Project Plan
                </a>
              </li>
              <li>
                <a
                  className="italic font-medium"
                  href={Written_Instructions}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Step by Step Instructions for PFAS Sampling
                </a>
              </li>
              <li>
                <a
                  className="italic font-medium"
                  href={Background_Info}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  PFAS Sampling Preparation
                </a>
              </li>
              <br />
              <li className="font-medium">Sampler Training Video Part 1</li>
              <div style={videoContainerStyle(1)}>
                <iframe
                  ref={iframeRef1}
                  src={trainingP1VideoUrl}
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                  className="absolute top-0 left-0 w-full h-full"
                  title="Sampler Training Video Part 1"
                ></iframe>
              </div>
              <li className="font-medium">Sampler Training Video Part 2</li>
              <div style={videoContainerStyle(2)}>
                <iframe
                  ref={iframeRef2}
                  src={trainingP2VideoUrl}
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                  className="absolute top-0 left-0 w-full h-full"
                  title="Sampler Training Video Part 2"
                ></iframe>
              </div>
            </ul>
          </div>
        </div>

        <div className="text-md font-semibold my-4 text-gray-700">
          <h2 className="font-bold text-lg">Project Documents</h2>
          <div className="text-gray-700 text-md my-4">
            <ul className="list-disc ml-5">
              <li>
                <a
                  className="italic font-medium"
                  href={Communication_Plan_pdf}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Communication Plan
                </a>
              </li>
            </ul>
          </div>
        </div>
      </MainContainer>
    </section>
  );
};

export default Resources;
